module.exports = __webpack_public_path__ + "img/candidate.e1a8934f.svg";